import React from "react";
import SmallSlidePanel from "../add_customer/SmallSlidePanel";

const CustomerResetPassword = ({
  id,
  isCustomerResetPasswordModalOpen,
  closeCustomerResetPassword,
  handleAdminResetPassword,
}) => {
  const handleCancelButtonCLick = () => {
    closeCustomerResetPassword();
  };

  return (
    <SmallSlidePanel
      isOpen={isCustomerResetPasswordModalOpen}
      onClose={closeCustomerResetPassword}
      width={650}
      showCloseButton={false}
    >
      <div id={id} className="flex flex-col justify-center h-full px-6 py-6">
        <div className="mb-5">
          <div className="flex flex-col">
            <p className="text-[#000000] text-[20px] font-[400]">
              Are you sure you want to reset password of this member
            </p>

            <div>
              <p className="text-[#000000] text-[16px] font-[300] mt-3">
                A password reset link will be sent to their email.
              </p>
            </div>
          </div>

          <div className="flex items-center mt-8">
            <div className="mr-5">
              <button
                onClick={handleCancelButtonCLick}
                data-modal-toggle={id}
                type="button"
                className="text-[#074073] hover:bg-[#7FB8EB] focus:outline-none font-[500] rounded-[5px] text-md px-5 py-3 text-center bg-[#7FB8EB]"
              >
                No, cancel
              </button>
            </div>

            <button
              onClick={handleAdminResetPassword}
              data-modal-toggle={id}
              type="button"
              className="text-[#FFF] bg-[#074073] hover:bg-[#074073] focus:outline-none font-[500] rounded-[5px] text-[16px] text-medium px-12 py-3 text-center"
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </SmallSlidePanel>
  );
};

export default CustomerResetPassword;
